export default __webpack_public_path__ + "static/media/mail.41c9a642.svg";